module.exports = __webpack_public_path__ + "img/4s.b1f49d71.png";